/* eslint import/first: 0 */
import '@dxb-web-ui-framework/common/utils/DeveloperTools';

if (process.env.REACT_APP_MSW) {
  const { worker } = require('../../packages/mocks/src/msw/browser');
  worker.start();
}

import { ConnectedToUIStateStyledGlobalErrorBoundary } from '@dxb-web-ui-framework/common/components/GlobalErrorBoundary/GlobalErrorBoundary';
import { GlobalStyles } from '@dxb-web-ui-framework/common/components/GlobalStyles/GlobalStyles';
import { ScrollToTop } from '@dxb-web-ui-framework/common/components/ScrollToTop';
import { AppBootstrappingProvider } from '@dxb-web-ui-framework/common/contexts/AppBootstrapping/AppBootstrappingProvider';
import { AppConfigurationProvider } from '@dxb-web-ui-framework/common/contexts/AppConfiguration/AppConfigurationProvider';
import { UIStateProvider } from '@dxb-web-ui-framework/common/contexts/UIState/UIStateProvider';
import { Brand } from '@dxb-web-ui-framework/common/domain/Brand/types';
import { Channel } from '@dxb-web-ui-framework/common/domain/Channel/types';
import { Tenant } from '@dxb-web-ui-framework/common/domain/Tenant/types';
import { reportWebVitals } from '@dxb-web-ui-framework/common/utils/ReportWebVitals';
import { CssBaseline, ECOMMBX, MuiThemeProvider } from '@dxb-web-ui-framework/design-system';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { AppError } from '../../packages/content-composer/src/components/Generic/AppError';
import { AppLoader } from '../../packages/content-composer/src/components/Generic/AppLoader';
import { ReactKeycloakProvider } from '../../packages/iam/src/context/KeycloakProvider';
import { InternationalizationProvider } from '../../packages/internationalization/src/contexts/Internationalization';
import { brandedAppConfig } from './buildtime-config/brandedAppConfig';
import { RootRouter } from './Router';
import { internationalizationService } from './services';

ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider theme={ECOMMBX}>
      <CssBaseline />
      <GlobalStyles />
      <AppBootstrappingProvider
        brand={Brand.ECOMMBX}
        channel={Channel.ECOMMBX}
        appName={Channel.SECURE_WEB}
        tenant={Tenant.ECOMMBX}
        userAgentType={Channel.WEB}>
        <UIStateProvider>
          <ConnectedToUIStateStyledGlobalErrorBoundary isRoot>
            <AppConfigurationProvider
              loaderComponent={<AppLoader />}
              errorComponent={
                <AppError message='Houston we have a problem. Failed to initialise app' btnLabel='Back to home' />
              }>
              <InternationalizationProvider
                internationalizationService={internationalizationService}
                loaderComponent={<AppLoader />}
                errorComponent={
                  <AppError
                    fullHeight
                    message='Houston we have a problem. Failed to load translations'
                    btnLabel='Back to home'
                  />
                }>
                <ReactKeycloakProvider
                  loaderComponent={<AppLoader />}
                  initOptions={brandedAppConfig.keycloakInitOptions(window.location.pathname)}>
                  <Router basename={brandedAppConfig.baseName}>
                    <ScrollToTop />
                    <RootRouter brandConfig={brandedAppConfig} />
                  </Router>
                </ReactKeycloakProvider>
              </InternationalizationProvider>
            </AppConfigurationProvider>
          </ConnectedToUIStateStyledGlobalErrorBoundary>
        </UIStateProvider>
      </AppBootstrappingProvider>
    </MuiThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
